define('v3/Common/Components/MainMenu/MainMenu.Component',[
	'jquery',
	'knockout',
	'module',
	'lodash',
	'env',
	'v3/Common/Models/enums',
	'lottieSvg',
	'v3/Common/Services/urlService',
	'v3/Common/Services/pageStateService',
	'text!v3/Common/Components/MainMenu/MainMenu.Component.html',
	'v3/Common/Bindings/SvgIcon.Binding',
	'v3/Common/Bindings/Menu.Binding'
], function ($, ko, module, _, env, enums, lottieSvg, urlService, pageStateService, htmlString) {
	function createStaticIcon ($elm, fragementId) {
		return $('<svg data-bind="svgIcon: \'' + fragementId + '\'"/>').appendTo($elm.find('a'));
	}

	function createAnimatedIcon ($elm, location, fragementId) {
		var ua = window.navigator.userAgent;
		if (ua.indexOf('Edge/') > 0 ||
			ua.indexOf('Trident/') > 0 ||
			ua.indexOf('MSIE ') > 0 ||
			(ua.indexOf('Safari') > 0 && ua.indexOf('Chrome') < 0)) {
			return createStaticIcon($elm, fragementId);
		} else {
			var animation = lottieSvg.loadAnimation({
				container: $elm.find('a').get(0),
				renderer: 'svg',
				loop: false,
				autoplay: false,
				autoloadSegments: false,
				path: env.paths.svgAnimations + location
			});

			return $elm.find('a')
				.addClass('withAnimation')
				.on('mouseenter touchend', function () {
					animation.play();
				})
				.on('mouseleave', function () {
					animation.stop();
				});
		}
	}

	function getSubjectGroupIdFromSearch () {
		var subjectGroupId = null;

		if (document.location.search) {
			_.each(document.location.search.substr(1).split('&'), function (q) {
				var i = q.split('=');
				if (i[0] && i[0].toLowerCase() === 'subjectgroupid') {
					var decodedValue = decodeURIComponent(i[1]).replace(/\+/g, ' ');
					if (!isNaN(decodedValue)) {
						subjectGroupId = parseInt(decodedValue);
					}
				}
			});
		}

		return subjectGroupId;
	}

	function MainMenuViewModel () {
		var self = this;
		var config = module.config();

		var $elm = $(config.icons.container);
		var $monitor = $elm.find(config.icons.monitor);
		var $reports = $elm.find(config.icons.reports);

		var $teach = $elm.find(config.icons.teach);

		createAnimatedIcon($teach, 'teach.json', 'Teacher');
		createAnimatedIcon($monitor, 'monitor.json', 'Exercises');
		createAnimatedIcon($reports, 'reports.json', 'Graph');

		var pageStateSubjectGroupId = pageStateService.getNumberObservable('subjectGroupId');

		self.home = config.actions.home;
		self.lessonPageUrl = urlService.lessonPageUrl();
		self.workingsets = config.actions.workingSets;

		self.teachPageUrl = ko.observable();

		var teachPageUrlUpdater = ko.computed(function () {
			urlService.teachPageUrl(pageStateSubjectGroupId()).done(function (url) {
				self.teachPageUrl(url);
			});
		});

		self.monitorPageUrl = ko.observable();
		var monitorPageUrlUpdater;
		var subjectGroupIdFromSearch = getSubjectGroupIdFromSearch();

		monitorPageUrlUpdater = ko.computed(function () {
			var subjectGroupId = pageStateSubjectGroupId() || subjectGroupIdFromSearch;

			urlService.monitorPageV4Url(subjectGroupId).done(function (url) {
				self.monitorPageUrl(url);
			});
		});

		self.reviewPageUrl = ko.observable();
		self.reviewPageUrl(urlService.reviewPageUrl());

		self.isHomeActive = ko.observable(env.pageInfo.mainMenuArea === enums.mainMenuArea.home);
		self.isLessonsActive = ko.observable(env.pageInfo.mainMenuArea === enums.mainMenuArea.lessons);
		self.isWorkingsetActive = ko.observable(env.pageInfo.mainMenuArea === enums.mainMenuArea.workingsets);
		self.isMonitorActive = ko.observable(env.pageInfo.mainMenuArea === enums.mainMenuArea.monitor);
		self.isReportsActive = ko.observable(env.pageInfo.mainMenuArea === enums.mainMenuArea.reports);

		// EducationPlan Reports
		if (document.URL.indexOf('EducationPlan/PupilProgress') > 0 && (window.location.hash.indexOf('pupilId') > 0 || window.location.hash.indexOf('pupilName') > 0)) {
			self.isLessonsActive(false);
			self.isReportsActive(true);
		}

		self.dispose = function () {
			teachPageUrlUpdater.dispose();
			if (monitorPageUrlUpdater) {
				monitorPageUrlUpdater.dispose();
			}
			if (self.monitorPageUrl && self.monitorPageUrl.dispose) {
				self.monitorPageUrl.dispose();
			}

			if (self.reviewPageUrl && self.reviewPageUrl.dispose) {
				self.reviewPageUrl.dispose();
			}
		};
	}

	return { viewModel: MainMenuViewModel, template: htmlString };
});
